export class PrepayContractValidation {
  Account = false;
  PrepayAmount = false;
  CropProtectionPrePayAmount = false;
}
